import { createReducer } from 'deox';

import { TSendEmailResponse } from '@/services/api/company';
import { sendEmailAction } from '@/redux/actions/company';
import { sendEmailUpdateState } from './send-email';

import { TVerifyEmailResponse } from '@/services/api/company';
import { verifyEmailAction } from '@/redux/actions/company';
import { verifyEmailUpdateState } from './verify-email';

import { TCreateCheckoutSessionResponse } from '@/services/api/company';
import { createCheckoutSessionAction } from '@/redux/actions/company';
import { createCheckoutSessionUpdateState } from './create-checkout-session';

import { TCreateBillingPortalSessionResponse } from '@/services/api/company';
import { createBillingPortalSessionAction } from '@/redux/actions/company';
import { createBillingPortalSessionUpdateState } from './create-billing-portal-session';

import { TLicensePriceResponse } from '@/services/api/company';
import { getLicensePriceAction } from '@/redux/actions/company';
import { getLicensePriceUpdateState } from './get-license-price';

import { TLicenseOverviewResponse } from '@/services/api/company';
import { getLicenseOverviewAction } from '@/redux/actions/company';
import { getLicenseOverviewUpdateState } from './get-license-overview';

export type TCompanyState = {
  sendEmailResponse?: TSendEmailResponse;
  verifyEmailResponse?: TVerifyEmailResponse;
  createCheckoutSessionResponse?: TCreateCheckoutSessionResponse;
  billingPortalResponse?: TCreateBillingPortalSessionResponse;
  licensePriceResponse?: TLicensePriceResponse;
  licenseOverviewResponse?: TLicenseOverviewResponse;
};

const initialState: TCompanyState = {
  sendEmailResponse: undefined,
  verifyEmailResponse: undefined,
  createCheckoutSessionResponse: undefined,
  billingPortalResponse: undefined,
  licensePriceResponse: undefined,
  licenseOverviewResponse: undefined,
};

const CompanyReducer = createReducer(initialState, (handleAction) => [
  handleAction(sendEmailAction.success, (state, action) => {
    const updatedState = sendEmailUpdateState(state, action);

    return updatedState;
  }),

  handleAction(verifyEmailAction.success, (state, action) => {
    const updatedState = verifyEmailUpdateState(state, action);

    return updatedState;
  }),

  handleAction(createCheckoutSessionAction.success, (state, action) => {
    const updatedState = createCheckoutSessionUpdateState(state, action);

    return updatedState;
  }),

  handleAction(createBillingPortalSessionAction.success, (state, action) => {
    const updatedState = createBillingPortalSessionUpdateState(state, action);

    return updatedState;
  }),

  handleAction(getLicensePriceAction.success, (state, action) => {
    const updatedState = getLicensePriceUpdateState(state, action);

    return updatedState;
  }),

  handleAction(getLicenseOverviewAction.success, (state, action) => {
    const updatedState = getLicenseOverviewUpdateState(state, action);

    return updatedState;
  }),
]);

export default CompanyReducer;
